'use strict'
import $ from 'jquery'
import CropperJs from 'cropperjs'
import Swal from 'sweetalert2'

const INIT_SELECTOR = '[data-cropper-init]'

const CROPPER_OPTIONS = {
    viewMode: 2,
    autoCropArea: 1,
    zoomable: true,
}

const MODAL_SELECTOR_ID = 'modalCropper'
const MODAL_IMAGE_SELECTOR_ID = 'imageCropper'
const LOADER_SELECTOR_ID = 'loadModule'
const BUTTON_SUCCESS_SELECTOR_ID = 'js-cropper__buttons-success'

export default class Cropper {

    constructor (editButton) {
        this.editButton = $(editButton)
        this.modalImage = $('#' + MODAL_IMAGE_SELECTOR_ID)
        this.modal = $('#' + MODAL_SELECTOR_ID)
        this.id = this.editButton.data('resultInput')

        let errors = this.validate()

        if (errors.length !== 0) {
            console.error(errors)
        } else {
            this.initiateEvents()
        }
    }

    validate () {
        let errors = [],
            resultInputSelector = this.editButton.data('resultInput'),
            fileInputSelector = this.editButton.data('fileInput'),
            imgSelector = this.editButton.data('img')

        this.title = this.editButton.data('title') || '~';

        if (typeof resultInputSelector === 'undefined') {
            errors.push('Не задан параметр data-result-input у ' + INIT_SELECTOR)
        } else {
            this.resultInput = $(resultInputSelector)
            if (this.resultInput.length === 0) {
                errors.push('Не найден элемент тексового инпуа ' + INIT_SELECTOR)
            }
        }

        if (typeof fileInputSelector === 'undefined') {
            errors.push('Не задан параметр data-file-input у ' + INIT_SELECTOR)
        } else {
            this.fileInput = $(fileInputSelector)
            if (this.fileInput.length === 0) {
                errors.push('Не найден элемент файлового импута ' + INIT_SELECTOR)
            }
        }

        if (typeof imgSelector === 'undefined') {
            errors.push('Не задан параметр data-img у ' + INIT_SELECTOR)
        } else {
            this.image = $(imgSelector)
            this.fancybox = this.image.parent('[data-fancybox]')
            if (this.image.length === 0) {
                errors.push('Не найдено изображение ' + INIT_SELECTOR)
            }
        }
        return errors
    }

    done (url) {
        imageCropper.src = url
        this.modal.modal({
            backdrop: 'static'
        })
    }

    cropFun (event) {
        let canvas
        this.modal.modal('hide')

        if (this.cropper) {
            canvas = this.cropper.getCroppedCanvas()
            if (canvas) {
                canvas.toBlob((blob) => {
                    let reader = new FileReader()
                    reader.readAsDataURL(blob)
                    reader.onloadend = () => {
                        console.log('Save this shit',this.id);
                        let base64data = reader.result
                        this.image.attr('src', base64data)
                        this.resultInput.val(base64data).data('base64img', base64data)
                        this.resultInput.change()
                    }
                })
            }
        }
    }

    validURL (url) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query urling
            '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator
        return !!pattern.test(url)
    }

    getImage (url) {
        return new Promise((resolve, reject) => {

            const urlModel = new URL(url)
            const hostname = urlModel.hostname

            // if (hostname !== 's3.eu-central-1.amazonaws.com') {
            //
            // }
            url = 'https://cors-anywhere.herokuapp.com/' + url

            const xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)

            xhr.responseType = 'blob'
            xhr.onloadstart = () => {
                loadModule.css({
                    'display': 'flex'
                })
            }
            xhr.onloadend = () => {
                loadModule.hide()
            }
            xhr.onreadystatechange = () => {
                if (xhr.readyState !== 4) {
                    return
                }
                if (xhr.status !== 200) {
                    const error = new Error(`Ошибка ${xhr.status}`)
                    error.code = xhr.statusText
                    reject(error)
                } else {
                    resolve(xhr.response)
                }
            }
            xhr.send()

        })
    }

    get src () {
        return this.image.attr('src')
    }

    set src (src) {
        this.modalImage.attr('src', src)
        this.image.attr('src', src)
        if (this.fancybox) {
            this.fancybox.attr('href', src)
        }
    }

    fileInputChanged (event) {
        console.log(this.id+ ' file input changed');
        const file = event.target.files[0]
        const reader = new FileReader()

        reader.onloadend = () => {
            this.src = reader.result;
            this.openEditor()
        }

        if (file) {
            reader.readAsDataURL(file)
        } else {
            this.image.src = ''
        }

        return false
    }

    openEditor () {
        if (this.hasImage()) {
            this.modal.find('[data-title]').text(this.title);
            this.src = this.src
            this.modal
                .off()
                .on('shown.bs.modal', () => {
                console.log('Cropper created');
                this.cropper = new CropperJs(this.modalImageElement, CROPPER_OPTIONS)
            }).on('hidden.bs.modal', (event) => {
                console.log('Cropper destroed');
                this.cropper.destroy()
            })

            /**
             * EDITOR EVENTS
             */

            $(document).on('click', '#' + BUTTON_SUCCESS_SELECTOR_ID, (e) => {
                return this.cropFun(e)
            })

            $(document).on('click', '#image-edit-turn-right', (e) => {
                e.preventDefault()
                this.cropper.rotate(90)
            })

            $(document).on('click', '#image-edit-turn-left', (e) => {
                e.preventDefault()
                this.cropper.rotate(-90)
            })

            $(document).on('click', '#image-edit-flip-horiz', (e) => {
                e.preventDefault()
                let flipOption = ( $(this).data('flip-option') || 1 ) ;
                $(this).data('flip-option', -(flipOption));
                this.cropper.scaleX(-(flipOption));

            })

            $(document).on('click', '#image-edit-flip-vertic', (e) => {
                e.preventDefault()
                let flipOption = ( $(this).data('flip-option') || 1 ) ;
                $(this).data('flip-option', -(flipOption));
                this.cropper.scaleY(-(flipOption));
            })

            $(document).on('click', '#image-edit-reset', (e) => {
                e.preventDefault()
                this.cropper.reset()
            })


            this.modal.modal({
                backdrop: 'static'
            })

        } else {
            Swal.fire('Изображение отсутствует')
        }
    }

    get modalImageElement () {
        return document.getElementById(MODAL_IMAGE_SELECTOR_ID)
    }

    hasImage () {
        return this.src !== ''
    }



    initiateEvents () {

        this.editButton.on('click', () => {
            this.openEditor()
        })

        this.fileInput.on('change', (event) => {
            console.log(this.id+' file input onChange');
            return this.fileInputChanged(event)
        })





    }

    static get modalTemplate () {
        return `<div class='modal fade' id='${MODAL_SELECTOR_ID}' tabindex='-1' role='dialog' aria-labelledby='modalLabel' aria-hidden='true'>
        <div class='modal-dialog modal-lg' role='document'>
            <div class='modal-content'>
            
                <div class='modal-header d-flex justify-content-between'>
                
                <div class="col">
                <h6 data-title>
               
</h6>
</div>
<div class="col-auto">
<button id='image-edit-turn-left' class='btn btn-outline-primary' style='cursor: pointer;' type='button'>
                        <i class='fa fa-undo' aria-hidden='true'></i>
                    </button>
                    <button id='image-edit-turn-right' class='btn btn-outline-primary' style='cursor: pointer;' type='button'>
                        <i class='fa fa-redo' aria-hidden='true'></i>
                    </button>   
                    <button id='image-edit-flip-horiz' data-flip-option='1' class='btn btn-outline-primary' style='cursor: pointer;' type='button'>
                        <i class="fas fa-arrows-alt-h"></i>
                    </button>
                    <button id='image-edit-flip-vertic' data-flip-option='1' class='btn btn-outline-primary' style='cursor: pointer;' type='button'>
                       <i class="fas fa-arrows-alt-v"></i>
</div>
                    
                    </button>
                </div>
                <div class='modal-body'>
                    <div class='img-container'>
                        <img id='${MODAL_IMAGE_SELECTOR_ID}' src='#' class='img-fluid' >
                    </div>
                </div>
                <div class='modal-footer d-flex justify-content-end'>
                    <button id='image-edit-reset' type='button' class='btn btn-outline-dark'>Сброс</button>
                    <button type='button' class='btn btn-outline-secondary' data-dismiss='modal'>Отмена</button>
                    <button type='button' class='btn btn-primary' id="${BUTTON_SUCCESS_SELECTOR_ID}">Принять</button>
                </div>
            </div>
        </div>
    </div>`
    }

    static get loaderTemplate () {
        return `<div id='${LOADER_SELECTOR_ID}' class='d-none'>
      <div id='loadModule__spinner'>
        <i class='fa fa-spinner fa-pulse'></i>
      </div>
    </div>`
    }

    static init () {

        /**
         * Проверяем наличие модального окна
         */
        if (!$(MODAL_SELECTOR_ID).length) {
            $('body').append(this.modalTemplate)
        }

        /**
         * Проверяем наличие окна загрузчика
         */
        if (!$(LOADER_SELECTOR_ID).length) {
            $('body').append(this.loaderTemplate)
        }

        /**
         * Инициируем кропперы с каждой кнопки data-cropper-init
         */
        $(INIT_SELECTOR).each(function (indx, editButton) {
             new Cropper(editButton)
        })
    }
}

Cropper.init()


